import { createFeatureSelector, createSelector, select } from '@ngrx/store';
import { pipe } from 'rxjs';
import { filter } from 'rxjs/operators';

import { LicenseConfiguration } from '../license-configuration';

export const getConfigurationState = createFeatureSelector<
  LicenseConfiguration
>('license-configuration');

export const getConfiguration = createSelector(
  getConfigurationState,
  (configuration: LicenseConfiguration) => configuration,
);

export const candidateExternalUrl = createSelector(
  getConfiguration,
  (configuration: LicenseConfiguration) =>
    !!configuration && configuration.candidateExternalUrl,
);

export const jobExternalUrl = createSelector(
  getConfiguration,
  (configuration: LicenseConfiguration) =>
    !!configuration && configuration.jobExternalUrl,
);

export const getLicenseName = createSelector(
  getConfiguration,
  (configuration: LicenseConfiguration) =>
    !!configuration && configuration.licenseName,
);

export const loadLicenseExtensions = createSelector(
  getConfiguration,
  (configuration: LicenseConfiguration) =>
    !!configuration && configuration.licenseExtensions

);

export const hasExtensions = createSelector(
  loadLicenseExtensions,
  (extensions, { extension }) =>
    (extensions || []).some(ext => ext === extension)

);

export const isFeatureExtensionsLoaded = pipe(
  select(loadLicenseExtensions),
  filter((val) => val !== null),
);
